// extracted by mini-css-extract-plugin
export default {"cls1":"g5xc3ZmmldcKnYtS66ML","cls2":"KEx76V0M4UUCsN39y9dz g5xc3ZmmldcKnYtS66ML"};